/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgProgressLinear = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M18 8c2.206 0 4 1.794 4 4s-1.794 4-4 4H6c-2.206 0-4-1.794-4-4s1.794-4 4-4zm0 2H6c-1.103 0-2 .897-2 2s.897 2 2 2h12c1.103 0 2-.897 2-2s-.897-2-2-2zm-5 1v2H5v-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgProgressLinear as ProgressLinear };
